import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=22241643&scoped=true&"
import script from "./candidate.vue?vue&type=script&lang=js&"
export * from "./candidate.vue?vue&type=script&lang=js&"
import style0 from "./candidate.vue?vue&type=style&index=0&id=22241643&prod&scoped=true&lang=css&"
import style1 from "./candidate.vue?vue&type=style&index=1&id=22241643&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22241643",
  null
  
)

export default component.exports